function ChevronSvg({ isLeft = false }: { isLeft?: boolean }) {
  if (isLeft) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="18"
        fill="none"
        viewBox="0 0 10 18"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M0 9a.75.75 0 01.228-.539l8-7.75A.75.75 0 119.272 1.79L1.828 9l7.444 7.211a.75.75 0 01-1.044 1.078l-8-7.75A.75.75 0 010 9z"
          clipRule="evenodd"
        ></path>
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="18"
      fill="none"
      viewBox="0 0 10 18"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10 9a.75.75 0 01-.228.539l-8 7.75A.75.75 0 01.728 16.21L8.172 9 .728 1.789A.75.75 0 111.772.71l8 7.75A.75.75 0 0110 9z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default ChevronSvg;
